import type { Template } from 'state/selectedTemplate/selectedTemplateStore';
import { getDisplayName } from 'utils/names';

export const sortNodesInTemplate = (template: Template): Template => {
  const nodes = sortNodes(template.nodes);
  return { ...template, nodes };
};

const sortNodes = (nodes: Template['nodes']) => {
  // DO NOT filter out nodes that cannot be displayed.
  // They are hidden file-attachment nodes, which are still needed in some places.
  return nodes.sort((nodeA, nodeB) => {
    const nameA = getDisplayName(nodeA.displayNames);
    const nameB = getDisplayName(nodeB.displayNames);

    return nameA.localeCompare(nameB);
  });
};
